import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

const StoreHead = ({
  googleIndex = true,
  metaDescription = null,
  metaTitle = null,
}) => (
  <NextSeo
    description={metaDescription}
    nofollow={!googleIndex}
    noindex={!googleIndex}
    openGraph={{
      title: metaTitle,
      description: metaDescription,
    }}
    title={metaTitle}
  />
);

StoreHead.propTypes = {
  googleIndex: PropTypes.bool,
  metaDescription: PropTypes.string,
  metaTitle: PropTypes.string,
};

export default StoreHead;
